import './polyfills';
import React from 'react';
import domready from 'domready';
import Logger from './Logger';
import { render } from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { persistor, store } from './store/store';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { config } from './config';
import { createIntl } from 'react-intl';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl-redux';
import LoadingView from './components/Loader/LoadingView';
import MainApp from './App';
import './index.css';
const logger = new Logger();

const intl = createIntl({ locale: 'en', defaultLocale: 'en' });

const theme = createMuiTheme(config.theme);

domready(() =>
{
	logger.debug('DOM ready');

	run();
});

function run()
{
	logger.debug('run() [environment:%s]', process.env.NODE_ENV);

	render(
		<Provider store={store}>
			<MuiThemeProvider theme={theme}>
				<IntlProvider value={intl}>
					<PersistGate loading={<LoadingView />} persistor={persistor}>
						<MainApp />
					</PersistGate>
				</IntlProvider>
			</MuiThemeProvider>
		</Provider>,
		document.getElementById('edumeet')
	);
}

serviceWorker.unregister();